import _ from 'lodash';
import { connect } from 'react-redux';
import { add, update, get} from '../../modules/inventory/fuelContract';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	const fuelContractId = _.get(ownProps, ['match', 'params', 'fuelContractId']);
	const fuelContract = (fuelContractId) ? _.get(state.maps, ['fuelContract', fuelContractId]) : undefined;

	return {
		fuelContract,
		userMap : state.maps.user,
		supplierMap : state.maps.supplier,
		terminalMap : state.maps.terminal,
		resourceMap : state.maps.resource,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	addFuelContract : add,
	updateFuelContract : update,
	getFuelContract : get,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
